/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  HTTPValidationError,
} from '../models/index';
import {
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
} from '../models/index';

export interface UploadImageRequest {
    file: Blob;
}

/**
 * 
 */
export class UploadsApi extends runtime.BaseAPI {

    /**
     * Upload an image file for use in rich text editor.  Requires a content creator, competition organizer or administrator role in a licensed organization, ownership of a licensed organization, or superadmin.  Args:     current_user: Currently authenticated user     session: Database session     file: Image file to upload (JPEG, PNG, GIF, WebP)  Returns:     Dictionary containing the public URL and filename  Raises:     HTTPException 401: If user is not authenticated     HTTPException 403: Organization license required (no licensed authoring role)     HTTPException 400: Wrong file type or extension, or an empty file     HTTPException 413: Larger than the image size limit (read in pieces, never past it)     HTTPException 500: If upload fails
     * Upload Image
     */
    async uploadImageRaw(requestParameters: UploadImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: string | null; }>> {
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling uploadImage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        const response = await this.request({
            path: `/uploads/image`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Upload an image file for use in rich text editor.  Requires a content creator, competition organizer or administrator role in a licensed organization, ownership of a licensed organization, or superadmin.  Args:     current_user: Currently authenticated user     session: Database session     file: Image file to upload (JPEG, PNG, GIF, WebP)  Returns:     Dictionary containing the public URL and filename  Raises:     HTTPException 401: If user is not authenticated     HTTPException 403: Organization license required (no licensed authoring role)     HTTPException 400: Wrong file type or extension, or an empty file     HTTPException 413: Larger than the image size limit (read in pieces, never past it)     HTTPException 500: If upload fails
     * Upload Image
     */
    async uploadImage(requestParameters: UploadImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: string | null; }> {
        const response = await this.uploadImageRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
